import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Button } from '@mui/material';
//import { exec } from 'child_process';

interface IDownloadMenuProps {
  children: JSX.Element | string;
  image: string;
}

const DownloadMenu = ({ children, image }: IDownloadMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleDownload = async () => {
  // await openBrowser(image, { app: 'google chrome' });
  //exec(`open -a "Google Chrome" ${image}`);
  // };

  return (
    <div>
      <span
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {children}
      </span>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClose}>
          <Button>
            {' '}
            <a
              style={{ textDecoration: 'none', color: 'inherit' }}
              href={image}
              download
            >
              Download
            </a>
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default DownloadMenu;
